import { createWebSocketStore } from 'src/services/api/reallis/helpers';
export const getAllConfirmationActions = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'admin',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'confirmation_getAllActions',
    },
});
export const getNotConfirmedActionsCount = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'admin',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'confirmation_getNotConfirmedActions',
    },
});
export const deleteAction = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'admin',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'confirmation_deleteAction',
    },
});
export const addSolutionAdmin = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'admin',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'confirmation_addSolutionAdmin',
    },
});
export const addSolutionAdminForMany = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'admin',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'confirmation_addSolutionAdminForMany',
    },
});
